// Las etiquetas G-20RX0W3EFZ y AW-18511996126 se cargan en public/index.html.
// Aquí solo se dispara la conversión al enviar el formulario.
const GOOGLE_ANALYTICS_ID = "G-20RX0W3EFZ";
const GOOGLE_ADS_ID = "AW-18511996126";
const CONVERSION_TIMEOUT_MS = 2000;

const LANDINGS = {
  outsourcing: { conversionLabel: "S_XeCLy3gpwdEN7JmvtE" },
  consumibles: { conversionLabel: "" },
};

function getGtag() {
  if (typeof window.gtag === "function") return window.gtag;
  window.dataLayer = window.dataLayer || [];
  return function gtag() {
    window.dataLayer.push(arguments);
  };
}

export function initAnalytics() {}

export function initTracking() {}

export function trackLead(landing) {
  return new Promise((resolve) => {
    let settled = false;
    const done = () => {
      if (settled) return;
      settled = true;
      resolve();
    };

    const send = getGtag();

    send("event", "generate_lead", {
      send_to: GOOGLE_ANALYTICS_ID,
      form_name: landing,
    });

    const label = LANDINGS[landing]?.conversionLabel;
    if (!label) {
      done();
      return;
    }

    const timer = window.setTimeout(done, CONVERSION_TIMEOUT_MS);
    send("event", "conversion", {
      send_to: `${GOOGLE_ADS_ID}/${label}`,
      value: 1.0,
      currency: "COP",
      event_callback: () => {
        window.clearTimeout(timer);
        done();
      },
      event_timeout: CONVERSION_TIMEOUT_MS,
    });
  });
}
